// Auto-generated by scripts/generate-registry.mjs from packages/modules/wave_relief_pen_cup/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const wave_relief_pen_cup: ModuleSchema = {
  "id": "wave_relief_pen_cup",
  "uniqueId": "B3D_T79O1",
  "createdAt": "2026-10-28T06:54:55.859Z",
  "updatedAt": "2026-10-28T06:54:55.860Z",
  "label": "Wave Relief Cup",
  "description": "Type B open-top cylindrical pen cup with continuous wall-backed wave relief and one final union body.",
  "category": "rattan",
  "tags": [
    "wave-relief-pen-cup"
  ],
  "sliders": [
    {
      "key": "diameter",
      "label": "Outer Diameter",
      "min": 50,
      "max": 120,
      "default": 72,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "height",
      "label": "Cup Height",
      "min": 30,
      "max": 140,
      "default": 80,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "union_body",
      "label": "Wall + Continuous Backing + Wave Rows",
      "default": "#9a633d",
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "id": "cup_body",
      "label": "Wave Relief Cup",
      "name": "Wave Relief Cup",
      "color": "#9a633d",
      "assembled_z_offset": 0,
      "exploded_z_offset": 25,
      "parts": [
        {
          "id": "union_body",
          "label": "Wall + Continuous Backing + Wave Rows",
          "name": "Wall + Continuous Backing + Wave Rows",
          "groupId": 0,
          "colorKey": "union_body",
          "defaultColor": "#9a633d",
          "assembled_z_offset": 0,
          "exploded_z_offset": 25,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Union Body"
    }
  ]
};
